export default CadastroController;

import * as _ from 'lodash';

/** @ngInject */
function CadastroController(Usuario, Navegacao) {
  var vm = this;

  this.limpar = limpar;
  this.todosTelefones = false;
  this.toggleTelefones = toggleTelefones;
  this.cadastrar = cadastrar;
  this.tiposVeiculos = Usuario.tiposVeiculos;
  this.tiposCarroceria = Usuario.tiposCarroceria;

  limpar();

  function limpar() {
    vm.usuario = {
      id_tipo_veiculo: vm.tiposVeiculos[0],
      id_tipo_carroceria: vm.tiposCarroceria[0]
    };
  }

  function toggleTelefones() {
    vm.todosTelefones = !vm.todosTelefones;

    if (!vm.todosTelefones) {
      ['nr_telefone_fixo', 'nr_telefone_comercial'].map(limparInvalido);
    }
  }

  function limparInvalido(campo) {
    if ((vm.usuario[campo] || '').length < 10) {
      vm.usuario[campo] = '';
    }
  }

  function cadastrar() {
    let usuario = _.assign(vm.usuario, {
      id_tipo_veiculo: vm.usuario.id_tipo_veiculo && vm.usuario.id_tipo_veiculo.id,
      id_tipo_carroceria: vm.usuario.id_tipo_carroceria && vm.usuario.id_tipo_carroceria.id
    });

    Usuario
      .cadastrar(usuario)
      .then(() => Usuario.dialog('Cadastro realizado com sucesso!'))
      .then(() => Navegacao.voltar(true));
  }
}



/** WEBPACK FOOTER **
 ** ./pages/consulta/usuario/cadastro.controller.ts
 **/